<template>
  <div
    ref="registrationFormSteps"
    class="registration-steps"
  >
    <transition
      name="step"
      mode="out-in"
      @before-leave="onBeforeLeave"
      @before-enter="onBeforeEnter"
      @after-enter="onAfterEnter"
    >
      <registration-step-contact-data
        v-if="currentStep === 1"
        key="step-1"
        @valid-changed="(value) => $emit('valid-changed-step-contact-data', value)"
      />
      <registration-step-password
        v-else-if="currentStep === 2"
        key="step-2"
        no-recaptcha
        @valid-changed="(value) => $emit('valid-changed-step-password', value)"
      />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';

import RegistrationStepContactData from '@/components/registration/fischer/registration-steps/RegistrationStepContactData.vue';
import RegistrationStepPassword from '@/components/registration/fischer/registration-steps/RegistrationStepPassword.vue';
import { useRegistrationSteps } from '@/composables/registrationSteps';

defineOptions({ name: 'RegistrationLight' });

interface Props {
  currentStep?: number;
}

withDefaults(defineProps<Props>(), {
  currentStep: 1,
});

defineEmits<{
  'valid-changed-step-contact-data': [value: boolean];
  'valid-changed-step-password': [value: boolean];
}>();

const registrationFormSteps = useTemplateRef<HTMLElement>('registrationFormSteps');
const { onBeforeLeave, onBeforeEnter, onAfterEnter } = useRegistrationSteps(registrationFormSteps);
</script>

<style src="./registration-steps" />
